import { createBrowserRouter } from "react-router";
import { RootLayout } from "./components/layout/RootLayout";
import { ErrorBoundary } from "./components/layout/ErrorBoundary";

/**
 * Data-mode router with route-level code splitting. Each page is a lazy chunk;
 * the shell (layout + router runtime) stays in the initial bundle.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import("./pages/Home")).default }) },
      {
        path: "services",
        lazy: async () => ({ Component: (await import("./pages/Services")).default }),
      },
      { path: "about", lazy: async () => ({ Component: (await import("./pages/About")).default }) },
      {
        path: "contact",
        lazy: async () => ({ Component: (await import("./pages/Contact")).default }),
      },
      {
        path: "privacy",
        lazy: async () => ({ Component: (await import("./pages/Privacy")).default }),
      },
      { path: "*", lazy: async () => ({ Component: (await import("./pages/NotFound")).default }) },
    ],
  },
]);
